module.exports = __webpack_public_path__ + "media/images/icons/to-read-8619bb115879ee5780e017120c2fcd0d.svg";